module.exports = __webpack_public_path__ + "components/blogs-header/static/header--medium@2x-32c21d5c9bca4b4bd028ba885a395123.jpg";